import { apiFetch, buildQuery } from "./apiClient";
import type { SyncHistoryRow, SyncStatusRow, TriggerResponseData } from "../types/api";

/** GET /api/v1/sync/status — per-entity snapshot, six rows in chain order. */
export function getSyncStatus(): Promise<SyncStatusRow[]> {
  return apiFetch<SyncStatusRow[]>("/api/v1/sync/status");
}

export interface SyncHistoryParams {
  entity?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

/** GET /api/v1/sync/history — paginated past runs. */
export function getSyncHistory(params: SyncHistoryParams = {}): Promise<SyncHistoryRow[]> {
  return apiFetch<SyncHistoryRow[]>(`/api/v1/sync/history${buildQuery(params)}`);
}

/** GET /api/v1/sync/history/{runId} */
export function getSyncHistoryDetail(runId: number | string): Promise<SyncHistoryRow> {
  return apiFetch<SyncHistoryRow>(`/api/v1/sync/history/${runId}`);
}

/**
 * POST /api/v1/sync/trigger?entity=... — same admin auth as /api/v1/admin/*.
 * Returns 202 with an accepted marker.
 */
export function triggerSync(entity: string): Promise<TriggerResponseData> {
  return apiFetch<TriggerResponseData>(`/api/v1/sync/trigger${buildQuery({ entity })}`, {
    method: "POST",
  });
}
